import { default as baseEventlisteners } from './baseEventListeners/baseEventlisteners';
import { default as fogOfWars } from './fogOfWars/index';
import { default as hexagons } from './hexagons/index';
import { default as mapMovement } from './mapMovement/mapMovement';
import { default as minimaps } from './minimaps/index';
import { default as mapDrag } from './move/mapDrag';
import { default as mapZoom } from './zoom/mapZoom';

export default {
  baseEventlisteners,
  fogOfWars,
  hexagons,
  mapMovement,
  minimaps,
  mapDrag,
  mapZoom,
}


/** WEBPACK FOOTER **
 ** ./src/extensions/index.js
 **/